/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const AnimatedIconWrap = styled(motion.div)`
    width: 64px;
    height: 64px;
    display: grid;
    place-items: center;

    img {
        width: 64px;
        height: 64px;
        display: block;
        -webkit-user-select: none;
        user-select: none;
        pointer-events: none;
    }
`;

export const TitleText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const SubtitleText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #ff8a8a;
`;

export const ButtonsCol = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const PrimaryButton = styled.button`
    width: 100%;
    height: 44px;
    border-radius: 8px;
    padding: 10px;
    border: none;

    background: #5e84ed;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const SecondaryButton = styled.button`
    width: 100%;
    height: 44px;
    border-radius: 8px;
    padding: 10px;

    background: transparent;
    border: 1px solid transparent;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const SpinnerWrap = styled.div`
    margin-top: 12px;
    display: grid;
    place-items: center;
`;
